// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import type { ActiveClaimSession } from '@/services/claimSession';

export const hasClaimAccess = (claimSession: ActiveClaimSession | null | undefined): boolean =>
  !!claimSession?.claimAccessToken;

export const appendClaimQuery = (
  url: string,
  claimSession: ActiveClaimSession | null | undefined,
): string => {
  if (!claimSession) {
    return url;
  }

  const claimToken = claimSession.claimAccessToken?.trim();
  const claimClientId = claimSession.claimClientId?.trim();
  if (!claimToken && !claimClientId) {
    return url;
  }

  const params = new URLSearchParams();
  if (claimToken) {
    params.set('claimToken', claimToken);
  }
  if (claimClientId) {
    params.set('claimClientId', claimClientId);
  }

  const query = params.toString();
  if (!query) {
    return url;
  }

  return `${url}${url.includes('?') ? '&' : '?'}${query}`;
};

export const buildAccessHeaders = (userToken?: string | null): HeadersInit | undefined => {
  const normalized = userToken?.trim();
  if (!normalized) {
    return undefined;
  }

  return {
    Authorization: `Bearer ${normalized}`,
  };
};
